<svg xmlns="http://www.w3.org/2000/svg" width="101" height="101" viewBox="0 0 101 101">
  <defs>
    <filter id="jlq99dn41a">
      <feColorMatrix in="SourceGraphic" values="0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"/>
    </filter>
  </defs>
  <g fill="none" fill-rule="evenodd">
    <g>
      <g>
        <path d="M0 0H100.5V100.5H0z" transform="translate(-590 -259) translate(590 259)"/>
        <g fill="#000" fill-opacity=".35" stroke="#FFF" stroke-width="3" transform="translate(-590 -259) translate(590 259) translate(3.865 3.865)">
          <circle cx="47.046" cy="47.046" r="45.546"/>
        </g>
        <g filter="url(#jlq99dn41a)" transform="translate(-590 -259) translate(590 259)">
          <g transform="translate(27 27)">
            <path d="M0 0H47V47H0z"/>
            <rect width="12.011" height="44.613" x="6.267" y="1.567" fill="#A09EA3" rx="2"/>
            <rect width="12.011" height="44.613" x="30.289" y="1.567" fill="#A09EA3" rx="2"/>
          </g>
        </g>
      </g>
    </g>
  </g>
</svg>
